/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */

import React, { Component } from 'react';
import { projectService } from '../../services/project.service';
import { Input } from 'reactstrap';
import './RMS.css';
import { repoCloner, commandId } from './RMSData';
import { connect } from 'react-redux';

class RMS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projectName: '',
      sourceRepo: '',
      destinationRepo: '',
      sourceBranch: '',
      destinationBranch: '',
      prodDeploymentsData: [],
      openAddModal: false,
      dropDownOpen: false,
      autirProdDeployments: [],
      showData: null,
      autireEnvironments: [
        {
          envName: 'Autire-AI',
          branch: 'Autire-AI',
        },
      ],
      branchOptions: ['Autire-AI'],
    };
    this.toggle = this.toggle.bind(this);
    this.handleGitBranchReset = this.handleGitBranchReset.bind(this);
  }

  handleAddProdDeployment() {
    // let data = [...this.state.prodDeploymentsData];
    let deploymentData = {
      git_repo_branch_info: {
        'autire-ai': {
          git_repos: {
            source_repo: this.state.sourceRepo,
            destination_repo: this.state.destinationRepo,
          },
          git_branch_pairs: [
            {
              source_branch: this.state.sourceBranch,
              destination_branch: this.state.destinationBranch,
            },
          ],
        },
      },
    };
    // data.push(deploymentData);
    // this.setState({prodDeploymentsData:data,sourceRepo:'',destinationRepo:'',sourceBranch:'',destinationBranch:'',openAddModal:false,projectName:''},()=>{
    projectService.handlePostRequest(deploymentData);
    // });
  }
  toggle() {
    this.setState(prevState => ({ dropDownOpen: !prevState.dropDownOpen }));
  }

  changeRepository(e) {
    this.setState({ sourceBranch: e.target.value, autirProdDeployments: repoCloner });
  }

  handleSetCommandId(id) {
    let data = [...repoCloner];
    data[id]['command_id'] = commandId;
    this.setState({ autirProdDeployments: data });
  }

  async handleCheckStatus(i) {
    let data = [...repoCloner];
    let res = await projectService.getCommandStatus(commandId);
    if (res !== null) {
      data[i]['current_status'] = res.data.Status;
      this.setState({ autirProdDeployments: data });
    }
  }

  async handleGitBranchReset(id) {
    let requestData = {
      git_repo_branch_info: {
        'git-cloner-test-repo': {
          git_repos: ['git@bitbucket.org:prirosystemsinc/git-cloner-test-repo.git'],
          reset_branch: 'branch1',
        },
      },
    };
    let data = await projectService.gitBranchRefresher(requestData);
    this.setState(prevState => {
      let autirProdDeploymentsData = [...prevState.autirProdDeployments];
      autirProdDeploymentsData[id]['data'] = data;
      return { autirProdDeployments: autirProdDeploymentsData };
    });
  }

  render() {
    return (
      <div>
        <div className="rms-header">
          <img src="images/logo.png" alt="Autire" height={35} />
        </div>

        <div style={{ width: '16%', marginTop: '1%', marginLeft: '1%' }}>
          <Input
            value={this.state.sourceBranch}
            onChange={(e) => {
              this.changeRepository(e);
            }}
            type="select"
          >
            <option value={'NONE'}>{'Select Repository'}</option>
            {this.state.branchOptions.map((item, index) => {
              return (
                <option key={`branch-${index}-${item}`} value={item}>
                  {item}
                </option>
              );
            })}
          </Input>
        </div>

        <div className="tab-wrapper">
          <section className="tab-title">Environments</section>
        </div>

        <div style={{ width: '98%', marginLeft: '1%', marginTop: '2%' }}>
          {this.state.autirProdDeployments &&
            this.state.autirProdDeployments.length > 0 &&
            this.state.autirProdDeployments.map((item, index) => {
              let environmentName = Object.keys(item.git_repo_branch_info);
              let gitRepos = item.git_repo_branch_info[environmentName].git_repos;
              return (
                <div
                  key={index}
                  style={{
                    border: '1px solid #c7c7c7',
                    color: '#333333',
                    padding: '1%',
                    marginBottom: '2%',
                  }}
                >
                  <div className="card-sub-wrapper">
                    <section style={{ display: 'flex', alignItems: 'center', columnGap: '12px' }}>
                      <p className="repo-card-label-bold p-tag" style={{ fontSize: '20px' }}>
                        {environmentName}
                      </p>
                      {!Object.hasOwn(item, 'command_id') && (
                        <button
                          className="rms-card-button rms-font-size"
                          onClick={() => {
                            this.handleSetCommandId(index);
                            // this.handleAddProdDeployment()
                          }}
                        >
                          Deploy
                        </button>
                      )}
                    </section>
                    <section>
                      <p className="p-tag repo-card-label-bold  rms-font-size">Current Status</p>
                      <p className="p-tag rms-font-size">
                        {' '}
                        {Object.hasOwn(item, 'current_status')
                          ? item.current_status
                          : '--'}
                      </p>
                    </section>
                    <section></section>
                  </div>
                  <div className="card-sub-wrapper" style={{ marginTop: '1%', marginBottom: '1%' }}>
                    <section>
                      <p className="p-tag repo-card-label-bold  rms-font-size">Last Deployed At</p>
                      <p className="p-tag rms-font-size">--</p>
                    </section>
                    <section>
                      <p className="p-tag repo-card-label-bold rms-font-size">Last Commit</p>
                      <p className="p-tag rms-font-size" style={{ color: '#30b3e9' }}>
                        --
                      </p>
                    </section>
                    <section></section>
                  </div>
                  <div className="card-sub-wrapper">
                    <section>
                      <p className="p-tag repo-card-label-bold rms-font-size">Source Repo</p>
                      <p className="p-tag rms-font-size">{gitRepos.source_repo}</p>
                    </section>
                    <section>
                      <p className="p-tag repo-card-label-bold rms-font-size">Destination Repo</p>
                      <p className="p-tag rms-font-size">{gitRepos.destination_repo}</p>
                    </section>
                    <section style={{ textAlign: 'right' }}>
                      <button
                        className={
                          Object.prototype.hasOwnProperty.call(item, 'command_id') &&
                          item.command_id !== ''
                            ? 'rms-card-button'
                            : 'rms-card-button-disabled'
                        }
                        style={{ marginRight: '4%' }}
                        onClick={() => {
                          this.handleCheckStatus(index);
                        }}
                      >
                        Check Status
                      </button>
                      <button
                        className="rms-card-button"
                        onClick={() => {
                          this.handleGitBranchReset(index);
                        }}
                      >
                        Reset Environment
                      </button>
                    </section>
                  </div>
                  {Object.prototype.hasOwnProperty.call(item, 'data') && (
                    <div
                      style={{
                        border: '1px solid #333333',
                        borderRadius: '3px',
                        padding: '1%',
                        marginTop: '1%',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                        }}
                      >
                        <p className="p-tag">Logs</p>
                        <i
                          className={
                            this.state.showData == index ? 'fa fa-chevron-up' : 'fa fa-chevron-down'
                          }
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            this.setState(prevState => ({
                              showData:
                                prevState.showData == null
                                  ? index
                                  : prevState.showData == index
                                    ? null
                                    : index,
                            }));
                          }}
                          aria-hidden="true"
                        ></i>
                      </div>
                      {this.state.showData == index && (
                        <React.Fragment>
                          <hr></hr>
                          <pre style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap' }}>
                            {JSON.stringify(item.data, null, 2)}
                          </pre>
                        </React.Fragment>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { loader } = state;
  return {
    loader,
  };
}

// Mapping dispatch functions to props to access easily
const mapDispatchToProps = (dispatch) => ({
  gitBranchRefresher: (queryDetails, callback) =>
    dispatch(projectService.gitBranchRefresher(queryDetails, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RMS);
